'use strict';

module.exports = function() {
    $('body').on('click', '.qty-stepper .qty-minus', function () {
        var inputElement = $(this).closest('.qty-stepper').find('input');
        var val = parseInt(inputElement.val());
        val--;
        $(this).closest('.qty-stepper').find('input').val(val >= 0 ? val : 0).trigger('blur');
    }).on('click', '.qty-stepper .qty-plus', function () {
        var inputElement = $(this).closest('.qty-stepper').find('input');
        var val = parseInt(inputElement.val());
        val++;
        $(this).closest('.qty-stepper').find('input').val(val).trigger('blur');
    }).on('blur', '.qty-stepper input', function () {
        if ($(this).val() !== '') {
            var $val = parseInt($(this).val());
            $(this).val($val >= 0 ? $val : 0);
        }
    });
};
